import LoadingSpinner from "../../../components/LoadingSpinner";

const SpotRegisterAthleteStep1 = ({
  register,
  errors,
  watch,
  primaryPositions,
  selectedPosition,
  loading,
  onNext,
}) => {
  return (
    <div className="mb-10">
      <div className="flex items-center gap-3 mt-2 mb-1">
        <span className="text-sm font-semibold text-gray-400 uppercase tracking-wide whitespace-nowrap">
          Personal Information
        </span>
        <div className="flex-1 h-px bg-gray-500" />
      </div>
      <div className="grid sm:grid-cols-2 gap-x-6">
        <div className="form-field mt-4">
          <label htmlFor="firstName">First Name</label>
          <input
            {...register("firstName", { required: "Name is required" })}
            placeholder="First Name"
          />
          {errors.firstName && (
            <span className="text-red-500">{errors.firstName?.message}</span>
          )}
        </div>
        <div className="form-field mt-4">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            {...register("lastName", {
              required: "Last name is required",
            })}
            placeholder="Last Name"
          />
          {errors.lastName && (
            <span className="text-red-500">{errors.lastName?.message}</span>
          )}
        </div>

        <div className="form-field mt-4">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                message: "Invalid email address",
              },
            })}
            placeholder="Email"
          />
          {errors.email && (
            <span className="text-red-500">{errors.email?.message}</span>
          )}
        </div>
        <div className="form-field mt-4">
          <label htmlFor="confirmEmail">Confirm Email</label>
          <input
            id="confirmEmail"
            type="email"
            {...register("confirmEmail", {
              required: "Please confirm your email",
              validate: (v) =>
                v === watch("email") || "Email addresses do not match",
            })}
            placeholder="Confirm Email"
          />
          {errors.confirmEmail && (
            <span className="text-red-500">{errors.confirmEmail?.message}</span>
          )}
        </div>
        <div className="form-field mt-4">
          <label htmlFor="Password">Password</label>
          <input
            type="password"
            aria-invalid={errors.password ? "true" : "false"}
            name="password"
            {...register("password", {
              required: "Password is required",
            })}
            placeholder="Password"
          />
          {errors.password && (
            <span className="text-red-500">{errors.password?.message}</span>
          )}
        </div>
        <div className="form-field mt-4">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            type="password"
            {...register("confirmPassword", {
              required: "Please confirm your password",
              validate: (v) =>
                v === watch("password") || "Passwords do not match",
            })}
            placeholder="Confirm Password"
          />
          {errors.confirmPassword && (
            <span className="text-red-500">
              {errors.confirmPassword?.message}
            </span>
          )}
        </div>

        <div className="form-field">
          <label htmlFor="athletePhoneNumber">Athlete Phone Number</label>
          <input
            type="tel"
            id="athletePhoneNumber"
            inputMode="numeric"
            pattern="[0-9]{10}"
            placeholder="Athlete Phone Number"
            maxLength={10}
            {...register("athletePhoneNumber", {
              required: "Athlete Phone Number is required",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit phone number",
              },
            })}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
          />
          {errors.athletePhoneNumber && (
            <span className="text-red-500 text-sm">
              {errors.athletePhoneNumber?.message}
            </span>
          )}
        </div>

        <div className="form-field">
          <label htmlFor="parentPhoneNumber">Parent Phone Number</label>
          <input
            type="tel"
            id="parentPhoneNumber"
            inputMode="numeric"
            pattern="[0-9]{10}"
            placeholder="Parent Phone Number"
            maxLength={10}
            {...register("parentPhoneNumber", {
              required: "Parent Phone Number is required",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit phone number",
              },
            })}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
          />
          {errors.parentPhoneNumber && (
            <span className="text-red-500 text-sm">
              {errors.parentPhoneNumber?.message}
            </span>
          )}
        </div>

        <div className="form-field mt-4">
          <label
            htmlFor="primaryPosition"
            className="block text-base text-gray-900 dark:text-white"
          >
            Primary Position
          </label>
          <select
            id="primaryPosition"
            {...register("primaryPosition", {
              required: "Primary Position is required",
            })}
            className={`bg-gray-50 border border-gray-300 text-md rounded-md form-select appearance-none bg-no-repeat ${
              selectedPosition ? "text-gray-900" : "text-gray-400"
            }`}
          >
            <option value="" disabled className="text-gray-400">
              Select Primary Position
            </option>
            {primaryPositions.map((position) => (
              <option key={position} value={position} className="text-gray-900">
                {position === "Interior Offensive Line"
                  ? "Interior Offensive Line (Guard or Center)"
                  : position}
              </option>
            ))}
          </select>
          {errors.primaryPosition && (
            <span className="text-red-500">
              {errors.primaryPosition.message}
            </span>
          )}
        </div>

        <div className="form-field mt-4">
          <label htmlFor="expectedYearOfGraduation">
            Expected Year of Graduation
          </label>
          <input
            type="number"
            name="expectedYearOfGraduation"
            {...register("expectedYearOfGraduation", {
              required: "Expected Year of Graduation is required",
            })}
            placeholder="Expected Year of Graduation"
            min={2015}
            max={2035}
            step={1}
          />
          {errors.expectedYearOfGraduation && (
            <span className="text-red-500">
              {errors.expectedYearOfGraduation?.message}
            </span>
          )}
        </div>
      </div>

      <div className="form-field mt-4">{loading && <LoadingSpinner />}</div>
      <button
        type="button"
        onClick={onNext}
        className="bg-red-500 text-white uppercase rounded px-8 py-2 text-center mt-4 hover:bg-red-700 cursor-pointer w-full"
      >
        Next
      </button>
    </div>
  );
};

export default SpotRegisterAthleteStep1;
